<template>
	<div class="setup-view container-fluid">
		<div class="row">
			<div class="col-8 main">
				<div class="row">
					<erco-text-input class="col-12"
					                 label="Objektname"
					                 :text="objectname"
					                 :keepUnfocused="true"
					                 :forcePointerCursor="true"
					                 :forceFocusOutline="isSidebarFocused('objectname')"
					                 :tooltip="infoTextFor('setup.objectname')"
					                 @click="openSidebarFor('objectname')">
					</erco-text-input>
				</div>

				<div v-if="belongsToProductAreaOne" class="row">
					<erco-text-input class="col-12"
					                 label="PDB-Key"
					                 :text="pdbKey"
					                 :disabled="true"
					                 :keepUnfocused="true"
					                 :tooltip="infoTextFor('setup.pdbKey')">
					</erco-text-input>
				</div>

				<div class="row">
					<erco-text-input class="col-12"
					                 label="Objektzusatz"
					                 :text="objectadditional"
					                 placeholder="z. B.: Version 1.0"
					                 :keepUnfocused="true"
					                 :forcePointerCursor="true"
					                 :forceFocusOutline="isSidebarFocused('objectadditional')"
					                 :tooltip="infoTextFor('setup.objectadditional')"
					                 @click="openSidebarFor('objectadditional')">
					</erco-text-input>
				</div>

				<div class="row">
					<erco-text-input class="col-12"
					                 label="Redakteur (Ansprechpartner Gruppe Content)"
					                 :text="objecteditor"
					                 :keepUnfocused="true"
					                 :forcePointerCursor="true"
					                 :forceFocusOutline="isSidebarFocused('objecteditor')"
					                 :mandatory="true"
					                 :tooltip="infoTextFor('setup.objecteditor')"
					                 @click="openSidebarFor('objecteditor')">
					</erco-text-input>
				</div>


				<div class="row">
					<erco-text-input class="col-12"
					                 label="Designer (Ansprechpartner Gruppe Media)"
					                 :text="objectdesigner"
					                 :keepUnfocused="true"
					                 :forcePointerCursor="true"
					                 :forceFocusOutline="isSidebarFocused('objectdesigner')"
					                 :mandatory="true"
					                 :tooltip="infoTextFor('setup.objectdesigner')"
					                 @click="openSidebarFor('objectdesigner')">
					</erco-text-input>
				</div>

				<div v-if="isProject" class="row">
					<erco-text-input class="col-12"
					                 label="Land"
					                 :text="objectcountry"
					                 :keepUnfocused="true"
					                 :forcePointerCursor="true"
					                 :forceFocusOutline="isSidebarFocused('objectcountry')"
					                 :mandatory="true"
					                 :tooltip="infoTextFor('setup.objectcountry')"
					                 @click="openSidebarFor('objectcountry')">
					</erco-text-input>
				</div>

				<div class="row">
					<erco-text-input class="col-12"
					                 label="Spezifikation"
					                 :text="specification"
					                 :keepUnfocused="true"
					                 :tooltip="infoTextFor('setup.specification')"
					                 :disabled="true">
					</erco-text-input>
				</div>

				<div class="row">
					<erco-text-input class="col-12"
					                 label="Stammgattung"
					                 :text="basisgenus"
					                 :keepUnfocused="true"
					                 :forcePointerCursor="true"
					                 :forceFocusOutline="isSidebarFocused('basisgenus')"
					                 :tooltip="infoTextFor('setup.basisgenus')"
					                 @click="openSidebarFor('basisgenus')">
					</erco-text-input>
				</div>

				<div class="row">
					<erco-text-input class="col-12"
					                 label="Tags"
					                 :text="categories"
					                 :keepUnfocused="true"
					                 :forcePointerCursor="true"
					                 :forceFocusOutline="isSidebarFocused('categories')"
					                 :tooltip="infoTextFor('setup.categories')"
					                 @click="openSidebarFor('categories')">
					</erco-text-input>
				</div>

				<div class="row">
					<erco-text-input class="col-12" style="display:none;"
					                 label="Medienformate"
					                 :text="mediaformats"
					                 :keepUnfocused="true"
					                 :forcePointerCursor="true"
					                 :forceFocusOutline="isSidebarFocused('mediaformats')"
					                 :tooltip="infoTextFor('setup.mediaformats')"
					                 @click="openSidebarFor('mediaformats')">
					</erco-text-input>
				</div>

				<div class="row">
					<erco-text-input class="col-12"
					                 label="Dreiklang"
					                 :text="triad"
					                 :keepUnfocused="true"
					                 :forcePointerCursor="true"
					                 :forceFocusOutline="isSidebarFocused('triad')"
					                 :tooltip="infoTextFor('setup.triad')"
					                 @click="openSidebarFor('triad')">
					</erco-text-input>
				</div>

				<div v-if="isProject" class="row">
					<erco-text-input class="col-12"
					                 label="Verwendete Produkte"
					                 :text="linkedProducts"
					                 :keepUnfocused="true"
					                 :forcePointerCursor="true"
					                 :forceFocusOutline="isSidebarFocused('linkedProducts')"
					                 :tooltip="infoTextFor('setup.linkedProducts')"
					                 @click="openSidebarFor('linkedProducts')">
					</erco-text-input>
				</div>

				<div class="row">

					<div class="col-4" style="display:none;">
						<erco-checkbox-group label="Auf der Startseite"
						                     :options="startpageOptions"
						                     direction="vertical"
						                     :tooltip="infoTextFor('setup.startpage')"
						                     @change="handleStartpageChange">
						</erco-checkbox-group>
					</div>


					<div class="col-4">
						<erco-checkbox-group label="Einordnung im Light Scout"
						                     :options="lightscoutClassificationOptions"
						                     :tooltip="infoTextFor('setup.lightscoutClassification')"
						                     @change="handleLightscoutClassificationChange">
						</erco-checkbox-group>
					</div>
					<div class="col-4">
						<erco-checkbox-group label="Sichtbarkeit"
						                     :options="visibilityOptions"
						                     :tooltip="infoTextFor('setup.visibility')"
						                     @change="handleVisibilityChange">
						</erco-checkbox-group>
					</div>

					<div class="col-4">
						<erco-checkbox-group label="Synchsperre"
						                     :options="synchblockOptions"
						                     :tooltip="infoTextFor('setup.synchblock')"
						                     @change="handleSynchblockChange">
						</erco-checkbox-group>
					</div>
				</div>

			</div>

			<div class="col-4 aside">
				<div class="row">
					<div class="col-12">
						<div class="row">
							<div class="col-6">
								<label>Status</label>
								<erco-tooltip v-if="statusTooltip && statusTooltip.text"
								              :variant="statusTooltip.variant"
								              :title="statusTooltip.title"
								              :text="statusTooltip.text">
								</erco-tooltip>
								<b-dropdown	class="status-dropdown"
								            :text="currentSelectedStatusItem.text"
								            :variant="currentSelectedStatusItem.variant">
									<b-dropdown-item v-for="(item, index) in status.items"
									                 :key="index"
									                 :active="currentSelectedStatusItem.value === item.value"
									                 @click="handleStatusClick(item)">
										{{item.text}}
									</b-dropdown-item>
								</b-dropdown>
							</div>
							<div class="col-6 last-changes-link">
								<a href="#" @click.prevent="openSidebarFor('lastchanges')">Letzte Änderungen</a>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<erco-text-input class="col-12 publish-date"
									 label="Veröffentlichung planen"
									 :text="formatTimestamp(publishDateTime)"
									 placeholder="Nicht geplant"
									 :keepUnfocused="true"
									 :forcePointerCursor="true"
									 :tooltip="infoTextFor('setup.publishdatetime')"
									 :resetable="isValidPublishDateTime"
									 @reset="handlePublishDateTimeReset"
									 @click="openSidebarFor('publishdatetime')">
					</erco-text-input>
				</div>
				<div class="row">
					<erco-text-input class="col-12 go-offline-date"
					                 label="Offlinesetzen planen"
					                 :text="formatTimestamp(goOfflineDateTime)"
					                 placeholder="Nicht geplant"
					                 :keepUnfocused="true"
					                 :forcePointerCursor="true"
					                 :tooltip="infoTextFor('setup.gooffdatetime')"
					                 :resetable="isValidGoOfflineDateTime"
					                 @reset="handleGoOfflineDateTimeReset"
					                 @click="openSidebarFor('gooffdatetime')">
					</erco-text-input>
				</div>
				<!-- TODO: Auslagerung des Prozess-Formulars in eine eigene Komponente -->
				<div class="row">
					<div class="col-12">
						<div class="row">
							<div class="col-6">
								<label>Prozess</label>
								<erco-tooltip v-if="processTooltip && processTooltip.text"
								              :variant="processTooltip.variant"
								              :title="processTooltip.title"
								              :text="processTooltip.text">
								</erco-tooltip>
							</div>
						</div>

					</div>
				</div>

				<div class="process-block">
					<div class="row padding-bottom">
						<div class="col-12">
							<div class="approval-indicator"
							     :class="{'-error': !mandatoryFieldsStatus,
							              '-completed': mandatoryFieldsStatus }">
							</div>
							<!--<b-dropdown text="Pflichtfelder prüfen" size="md" class="fullwidth">
									<b-dropdown-item>Pflichtfelder prüfen</b-dropdown-item>
							</b-dropdown>-->
							<p class="helptext fullwidth">{{ mandatoryFieldsText }}</p>
						</div>
					</div>

					<div class="row padding-bottom"  v-for="item in pkStatus" :key="item[0]">
						<div class="col-12">
							<div class="approval-indicator"
							     :class="{'-progress': [1, 3, 4, 6, 8, 9, 10, 13, 14].indexOf(parseInt(getPkStatus(item[0]), 10)) !== -1,
							              '-completed': [2, 5, 7, 11, 15, 16].indexOf(parseInt(getPkStatus(item[0]), 10)) !== -1}">
							</div>
							<b-dropdown :text="getPkLabel(getPkStatus(item[0])) ? getPkLabel(getPkStatus(item[0])) : approval[item[0]]"
							            size="md"
							            class="fullwidth">
								<div v-for="(value, index) in item[1]" :key="index">
									<b-dropdown-item @click="handlePkStatusClick(value)">{{ value.S_Status_Aktion }}</b-dropdown-item>
								</div>
							</b-dropdown>
						</div>
					</div>
				</div>

				<div class="export-block">
					<a
						href="javascript:void(0);"
						class="id-text-rtf-export"
						@click="triggerIDTextRTFExport"
					>
						ID-Text für Übersetzung herunterladen
					</a>
				</div>

				<div class="row bottombar" v-if="change">
					<div class="col col-12">
						<div class="row info" v-if="change.info">
							<div class="col col-12">
								<b-alert class="info_" :variant="change.info.variant" show>
									<span class="_title" v-if="change.info.title">{{ change.info.title }}:</span>
									<span class="_text">{{ change.info.text }}</span>
								</b-alert>
							</div>
						</div>
						<div class="row controls">
							<div class="col col-auto">
								<b-button class="apply" variant="success" @click="handleAsideChangeWithPreCheck">Bestätigen</b-button>
								<b-button class="cancel" @click="handleAsideCancel">Abbrechen</b-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<b-modal id="action-confirmation"
		         ref="actionConfirmation"
		         class="action-confirmation-modal"
		         :title="actionConfirmationModalState.title"
		         closeTitle="Abbrechen"
		         @ok="handleAsideChange">
			<p class="_infotext">
				<span v-html="actionConfirmationModalState.text"></span>
			</p>
			<div class="selected-obj-list-container">
				<b-list-group class="selected-obj-list">
					<b-list-group-item class="_entry_">
						<span class="_title font-weight-bold">{{ objectname }}</span>
						<span class="_id float-left text-muted">{{ objectid }}</span>
						<span class="_badge">
							<erco-status-badge :status="objectstatus">
							</erco-status-badge>
						</span>
					</b-list-group-item>
				</b-list-group>
			</div>
		</b-modal>
	</div>
</template>

<script>

	import Const from '@/constants';
	import InfoText from '@/helper/infoTextHelper';
	import StringToColor from '@/helper/colorHelper';
	import ErcoTooltip from '@/components/molecules/ErcoTooltip';

	import ErcoStatusBadge from '@/components/atoms/ErcoStatusBadge';
	import ErcoTextInput from '@/components/molecules/ErcoTextInput';
	import ErcoRadioGroup from '@/components/molecules/ErcoRadioGroup';
	import ErcoCheckboxGroup from '@/components/molecules/ErcoCheckboxGroup';

	import moment from 'moment';

	const FileSaver = require('file-saver');


	const sidebarInputActions = {
		lastchanges() {
			const sidebarData = {
				visible: true,
				applied: true,
				key: 'lastchanges',
				view: 'erco-sidebar-last-changes',
				outputData: [],
				title: 'Letzte Änderungen',
				titleAdditional: '',
				info: InfoText.for('setup.lastchanges'),
			};

			sidebarData.outputData = this.dataset.S_Historie;

			return sidebarData;
		},

		objectname() {
			const maxChars = Const.max_chars['setup.objectname'];
			const titleAdditional = `(max. ${maxChars} Zeichen)`;

			const sidebarData = {
				visible: true,
				key: 'objectname',
				view: 'erco-sidebar-text-input',
				outputData: [],
				context: {
					dispatchActionName: 'updateObjectSetupObjectname',
					value: {},
				},
				title: 'Objektname',
				titleAdditional,
				info: InfoText.for('setup.objectname', { maxChars }),
				applied: false,
			};

			Const.langs.forEach((lang) => {
				if (this.dataset[`S_${lang.key}_Objekt`] === Const.NO_CONTENT) return;

				const objectText = this.dataset[`S_${lang.key}_Objekt`] || '';

				const entry = {
					key: lang.key,
					label: lang.text,
					text: objectText,
					charlength: maxChars,
				};

				sidebarData.outputData.push(entry);
			});

			return sidebarData;
		},

		pdbKey() {
			const sidebarData = {
				visible: true,
				key: 'pdbKey',
				view: 'erco-sidebar-text-input',
				outputData: [],
				context: {
					dispatchActionName: 'updateObjectSetupPDBKey',
					value: {},
				},
				title: 'PDB-Key',
				titleAdditional: '',
				info: InfoText.for('setup.pdbKey'),
			};

			sidebarData.outputData.push({
				key: 'pdbKey',
				label: '',
				text: this.pdbKey,
			});

			return sidebarData;
		},

		objectadditional() {
			const sidebarData = {
				visible: true,
				key: 'objectadditional',
				view: 'erco-sidebar-text-input',
				outputData: [],
				context: {
					dispatchActionName: 'updateObjectSetupObjectAdditional',
					value: {},
				},
				title: 'Objektzusatz',
				titleAdditional: '',
				info: InfoText.for('setup.objectadditional'),
			};

			sidebarData.outputData.push({
				key: 'objectadditional',
				label: '',
				text: this.objectadditional,
			});

			return sidebarData;
		},

		objecteditor() {
			const sidebarData = {
				visible: true,
				key: 'objecteditor',
				view: 'erco-sidebar-dropdown',
				outputData: [],
				context: {
					dispatchActionName: 'updateObjectSetupObjectEditor',
					value: {},
				},
				title: 'Redakteur',
				titleAdditional: '',
				info: InfoText.for('setup.objecteditor'),
			};

			const enums = this.objectusers.map(user => ({
				label: user.PKM_Nutzername,
				value: user.PKM_Nutzername,
			}));

			sidebarData.outputData.push({
				key: 'objecteditor',
				label: '',
				enum: [{ label: 'Bitte auswählen', value: '' }, ...enums],
				value: this.objecteditor,
			});

			return sidebarData;
		},

		objectdesigner() {
			const sidebarData = {
				visible: true,
				key: 'objectdesigner',
				view: 'erco-sidebar-dropdown',
				outputData: [],
				context: {
					dispatchActionName: 'updateObjectSetupObjectDesigner',
					value: {},
				},
				title: 'Designer',
				titleAdditional: '',
				info: InfoText.for('setup.objectdesigner'),
			};

			const enums = this.objectusers.map(user => ({
				label: user.PKM_Nutzername,
				value: user.PKM_Nutzername,
			}));

			sidebarData.outputData.push({
				key: 'objectdesigner',
				label: '',
				enum: [{ label: 'Bitte auswählen', value: '' }, ...enums],
				value: this.objectdesigner,
			});

			return sidebarData;
		},

		objectcountry() {
			const sidebarData = {
				visible: true,
				key: 'objectcountry',
				view: 'erco-sidebar-dropdown',
				outputData: [],
				context: {
					dispatchActionName: 'updateObjectProjectToCountry',
					value: {},
				},
				title: 'Land',
				titleAdditional: '',
				info: InfoText.for('setup.objectcountry'),
			};

			const enums = this.countries.map(country => ({
				label: country.S_Land,
				value: country.PKM_Land,
			}));

			sidebarData.outputData.push({
				key: 'objectcountry',
				label: '',
				enum: [{ label: 'Bitte auswählen', value: '' }, ...enums],
				value: this.objectcountrykey,
			});

			return sidebarData;
		},

		basisgenus() {
			const sidebarData = {
				visible: true,
				key: 'basisgenus',
				view: 'erco-sidebar-basisgenus',
				outputData: {
					draggable: [],
					destinations: [],
				},
				context: {
					dispatchActionName: 'updateObjectSetupBasisGenus',
					value: {},
				},
				title: 'Stammgattung',
				titleAdditional: 'Gattungen auf die Felder ziehen',
				info: InfoText.for('setup.basisgenus'),
				applied: false,
			};

			this.dataset.gattungen.forEach((gattung) => {
				const id = gattung.PKM_Gattung;
				const value = gattung.S_Gattung;
				const text = `${value} (${id})`;
				const short = gattung.S_Kurzbezeichnung;

				sidebarData.outputData.draggable.push({
					id,
					value,
					text,
					short,
				});
			});

			let destinations = [];

			destinations.push({
				key: 0,
				type: 'basis',
				data: {
					PKM_Gattung: this.dataset.FKM_Gattung,
					S_Gattung: this.dataset.S_Gattung || '',
				},
			});

			[2, 3, 4, 5, 6].forEach((traitNum) => {
				destinations.push({
					key: traitNum,
					type: 'trait',
					data: {
						PKM_Gattung: this.dataset[`FKM_Gattung${traitNum}`],
						S_Gattung: this.dataset[`S_Gattung${traitNum}`] || '',
					},
				});
			});

			destinations = destinations.map((entry) => {
				const key = entry.key;
				const type = entry.type;
				const label = (entry.type === 'basis') ? 'Stammgattung' : 'Merkmal';
				let id = '0';
				let text = '';

				if (entry.data) {
					id = entry.data.PKM_Gattung;
					text = entry.data.S_Gattung;
				}

				return {
					id,
					key,
					label,
					text,
					type,
				};
			});

			sidebarData.outputData.destinations = destinations;

			return sidebarData;
		},

		categories() {
			const sidebarData = {
				visible: true,
				key: 'categories',
				view: 'erco-sidebar-tags',
				outputData: {
					tags: [],
					suggestionAction: 'getCategorySuggestions',
				},
				context: {
					dispatchActionName: 'updateObjectSetupCategories',
					value: {
						tags: {},
					},
				},
				title: 'Tags',
				titleAdditional: 'Tags verwalten',
				info: InfoText.for('setup.categories'),
				applied: false,
			};

			if (this.dataset.tags) {
				let tags = this.dataset.tags;

				if (tags.result) {
					tags = tags.result;
					const tagKeys = [];

					Object.entries(tags).forEach((entry) => {
						tagKeys.push(entry[0]);
					});

					sidebarData.outputData.tags = tagKeys.map((tagKey) => {
						const tag = tags[tagKey];

						return {
							id: tag.PKM_Tag,
							text: tag.S_Value,
							s_attribut: tag.S_Attribut,
							s_type: tag.S_Type,
							color: StringToColor.colorstring(tag.S_Type),
						};
					});
				}
			}

			return sidebarData;
		},

		triad() {
			const sidebarData = {
				visible: true,
				key: 'triad',
				view: 'erco-sidebar-triad',
				outputData: {
					tabs: [],
				},
				context: {
					dispatchActionName: 'updateObjectSetupTriad',
					value: {},
				},
				title: 'Dreiklang',
				titleAdditional: 'Kontextlinks verwalten',
				info: InfoText.for('setup.triad'),
				applied: false,
			};

			[{ key: 'produkte_objekte', title: 'Produkte' },
			 { key: 'projekte_objekte', title: 'Projekte' }].forEach((branch) => {
				const branchData = this.dataset.dreiklang[branch.key];

				const tab = {
					title: branch.title,
					key: branch.key,
					groups: [],
				};

				(branchData || []).forEach((genus) => {
					const group = {
						title: genus.S_Gattung,
						key: genus.PKM_Gattung,
						items: [],
					};

					(genus.objekte || []).forEach((item) => {
						group.items.push({
							id: item.PKM_Objekt,
							text: item.S_Objekt,
							additional: item.S_Zusatz,
							selected: item.selected === 'true',
						});
					});

					tab.groups.push(group);
				});

				sidebarData.outputData.tabs.push(tab);
			});

			return sidebarData;
		},

		linkedProducts() {
			const sidebarData = {
				visible: true,
				key: 'linkedProducts',
				view: 'erco-sidebar-linked-products',
				outputData: {
					tabs: [],
				},
				context: {
					dispatchActionName: 'updateObjectSetupLinkedProducts',
					value: {},
				},
				title: 'Verwendete Produkte',
				titleAdditional: 'Produktverknüpfungen verwalten',
				info: InfoText.for('setup.linkedProducts'),
				applied: false,
			};

			const branch = {
				key: 'verwendete_produkte_objekte',
				title: 'Verwendete Produkte',
			};
			const data = this.dataset.verwendete_produkte[branch.key];

			const tab = {
				title: branch.title,
				key: branch.key,
				groups: [],
			};

			(data || []).forEach((genus) => {
				const group = {
					title: genus.S_Gattung,
					key: genus.PKM_Gattung,
					items: [],
				};

				(genus.objekte || []).forEach((item) => {
					group.items.push({
						id: item.PKM_Objekt,
						text: item.S_Objekt,
						additional: item.S_Zusatz,
						selected: item.selected === 'true',
					});
				});

				tab.groups.push(group);
			});

			sidebarData.outputData.tabs.push(tab);

			return sidebarData;
		},

		publishdatetime() {
			const sidebarData = {
				visible: true,
				key: 'publishdatetime',
				view: 'erco-sidebar-date-time-picker',
				outputData: {
					datetime: null,
				},
				context: {
					dispatchActionName: 'updateObjectSetupPublishDateTime',
					value: {},
				},
				title: 'Veröffentlichung',
				titleAdditional: 'Zeitpunkt der Veröffentlichung setzen',
				info: InfoText.for('setup.publishdatetime'),
				applied: false,
			};

			const publishDateTime = moment(this.publishDateTime, Const.DATETIMEFORMAT);

			if (publishDateTime.isValid()) {
				sidebarData.outputData.datetime = publishDateTime.toDate();
			}

			return sidebarData;
		},

		gooffdatetime() {
			const sidebarData = {
				visible: true,
				key: 'gooffdatetime',
				view: 'erco-sidebar-date-time-picker',
				outputData: {
					datetime: null,
				},
				context: {
					dispatchActionName: 'updateObjectSetupGoOfflineDateTime',
					value: {},
				},
				title: 'Offlinesetzung',
				titleAdditional: 'Zeitpunkt der Offlinesetzung',
				info: InfoText.for('setup.gooffdatetime'),
				applied: false,
			};

			const goOfflineDateTime = moment(this.goOfflineDateTime, Const.DATETIMEFORMAT);

			if (goOfflineDateTime.isValid()) {
				sidebarData.outputData.datetime = goOfflineDateTime.toDate();
			}

			return sidebarData;
		},
	};

	export default {
		name: 'ErcoObjectViewSetupOrganism',

		props: {
			dataset: {
				type: Object,
				required: true,
			},
		},

		data() {
			return {
				dirtySelectedStatusNum: null,
				change: null,
				approval: {
					redaktionellefreigabe: 'Red. Freigabe',
					uebersetzung: 'Übersetzung',
					technischefreigabe: 'Techn. Freigabe',
					endfreigabe: 'End-Freigabe',
					linkspruefen: 'Links prüfen',
					fremdsprachenpruefen: 'Fremdsprachen prüfen',
				},
				statusTooltip: InfoText.for('setup.status'),
				processTooltip: InfoText.for('setup.process'),
			};
		},

		computed: {
			username() {
				return this.$store.state.user.username;
			},

			mandatoryFieldsStatus() {
				return this.$store.getters.isMandatoryFilledOut;
			},

			mandatoryFieldsText() {
				return this.$store.getters.isMandatoryFilledOut ? 'Pflichtfelder vollständig' : 'Pflichtfelder unvollständig';
			},

			belongsToProductAreaOne() {
				return this.$store.state.objectsetup.current.FKM_Bereich === '1';
			},

			isProject() {
				return Const.specifications.projects.indexOf(this.dataset.FKM_Spezifikation) !== -1;
			},

			objectname() {
				const lang = this.dataset.sprache;
				const name = this.dataset[`S_${lang}_Objekt`];

				return name || '';
			},

			objectid() {
				return this.dataset.PKM_Objekt;
			},

			objectstatus() {
				return (this.dataset.FKM_Status &&
					    this.$store.getters.statiKey[this.dataset.FKM_Status] &&
					    this.$store.getters.statiKey[this.dataset.FKM_Status].S_Status) || '';
			},

			isProductive() {
				return this.$store.getters.objectIsProductive;
			},

			pdbKey() {
				return this.dataset.FKM_PKM_PDB.toString() || '';
			},

			objectadditional() {
				return this.dataset.S_Zusatz || '';
			},

			objectusers() {
				return this.dataset.nutzer || [];
			},

			objecteditor() {
				return this.dataset.FKM_Nutzername_Redakteur || '';
			},

			objectdesigner() {
				return this.dataset.FKM_Nutzername_Designer || '';
			},

			objectcountry() {
				/* TODO: Abfragen des Landes anpassen, wenn Länderliste ausgelagert wurde */
				if (!this.dataset.land) {
					return '';
				}
				const selectedCountry = this.dataset.land.find(country => country.selected === 'true');
				return (selectedCountry && selectedCountry.S_Land) || '';
			},

			objectcountrykey() {
				/* TODO: Abfragen des Landes anpassen, wenn Länderliste ausgelagert wurde */
				if (!this.dataset.land) {
					return '';
				}
				const selectedCountry = this.dataset.land.find(country => country.selected === 'true');
				return (selectedCountry && selectedCountry.PKM_Land) || '';
			},

			countries() {
				return this.$store.state.global.countries;
			},

			specification() {
				return this.dataset.S_Spezifikation || '';
			},

			basisgenus() {
				const basisgenusList = [];

				if (this.dataset.S_Gattung) {
					basisgenusList.push(this.dataset.S_Gattung);
				}

				[2, 3, 4, 5, 6].forEach((key) => {
					if (this.dataset[`S_Gattung${key}`]) {
						basisgenusList.push(this.dataset[`S_Gattung${key}`]);
					}
				});

				return basisgenusList.join(', ');
			},

			basisgenusArr() {
				return [1, 2, 3, 4, 5, 6].map((num) => {
					const propNamePostfix = (num === 1) ? '' : `${num}`;
					const type = (num === 1) ? 'basis' : 'trait';
					const idPropName = `FKM_Gattung${propNamePostfix}`;
					const titlePropName = `S_Gattung${propNamePostfix}`;

					return {
						id: this.dataset[idPropName] || '0',
						title: this.dataset[titlePropName] || '',
						type,
					};
				});
			},

			basisgenusDestinationsAreFull() {
				return !this.basisgenusArr.some(currGenus => currGenus.id === '0');
			},

			categories() {
				let categories = [];

				if (this.dataset.tags) {
					let tags = this.dataset.tags;

					if (tags.result) {
						tags = tags.result;
						const tagKeys = [];
						Object.entries(tags).forEach((entry) => {
							if (entry[1].S_Attribut) {
								tagKeys.push(entry[0]);
							}
						});
						categories = tagKeys.map(tagKey => tags[tagKey].S_Value);
					}
				}

				return categories.join(', ');
			},

			mediaformats() {
				let mediaformats = [];

				if (this.dataset.tags) {
					let tags = this.dataset.tags;

					if (tags.result) {
						tags = tags.result;
						const tagKeys = [];
						Object.entries(tags).forEach((entry) => {
							if (entry[1].S_Attribut === 'medienformat') {
								tagKeys.push(entry[0]);
							}
						});
						mediaformats = tagKeys.map(tagKey => tags[tagKey].S_Value);
					}
				}

				return mediaformats.join(', ');
			},

			triad() {
				const dreiklangEntries = [];

				['produkte_objekte', 'projekte_objekte'].forEach((key) => {
					if (!(this.dataset.dreiklang || {})[key]) {
						return;
					}
					const subDreiklang = this.dataset.dreiklang[key];
					subDreiklang.forEach((entry) => {
						entry.objekte.forEach((subEntry) => {
							if (subEntry.selected === 'true') {
								dreiklangEntries.push(subEntry.S_Objekt);
							}
						});
					});
				});

				return dreiklangEntries.join(', ');
			},

			linkedProducts() {
				const linkedProductsEntries = [];
				const branchKey = 'verwendete_produkte_objekte';

				if ((this.dataset.verwendete_produkte || {})[branchKey]) {
					const subLinkedProducts = this.dataset.verwendete_produkte[branchKey];
					subLinkedProducts.forEach((entry) => {
						entry.objekte.forEach((subEntry) => {
							if (subEntry.selected === 'true') {
								linkedProductsEntries.push(subEntry.S_Objekt);
							}
						});
					});
				}

				return linkedProductsEntries.join(', ');
			},

			sliderItems() {
				const keyTextMap = {
					homeheadslide: {
						text: 'Heroslider',
						order: 1,
					},
					homeheadslide_us: {
						text: 'Heroslider US',
						order: 2,
					},
					homeprojectslide: {
						text: 'Projektslider',
						order: 3,
					},
				};
				const keyTextMapKeys = Object.keys(keyTextMap);

				const sliderItems = (this.dataset.gattungen || []).filter(gattung =>
					keyTextMapKeys.includes(gattung.S_Kurzbezeichnung),
				);

				return sliderItems.map(option => ({
					value: option.PKM_Gattung,
					...keyTextMap[option.S_Kurzbezeichnung],
				}))
				.sort((a, b) => a.order - b.order);
			},

			startpageOptions() {
				const items = this.sliderItems;

				const enrichedItems = items.map((item) => {
					const genusIsSelected =
						this.basisgenusArr.some(currGenus => (currGenus.id === item.value.toString()));

					return {
						...item,
						checked: genusIsSelected,
						disabled: !genusIsSelected && this.basisgenusDestinationsAreFull,
					};
				});

				return enrichedItems;
			},

			lightscoutClassificationOptions() {
				return Const.langs.map((lang) => {
					const langEntry = {
						value: lang.key,
						text: lang.text,
					};

					if (this.dataset && this.dataset.sprachen) {
						langEntry.checked = this.dataset.sprachen[lang.key] === 1;
					}
					return langEntry;
				});
			},

			visibilityOptions() {
				return [{
					value: 'visibility',
					text: 'sichtbar',
					checked: this.dataset && this.dataset.B_Sichtbar === 'j',
				}];
			},
			synchblockOptions() {
				return [{
					value: 'synchblock',
					text: 'gesperrt',
					checked: this.dataset && this.dataset.B_Synchblock === 'j',
				}];
			},

			dirtySelectedStatus() {
				const statiItem = this.$store.getters.statiKey[this.dirtySelectedStatusNum];
				return (statiItem && statiItem.S_Status) || '';
			},

			actionConfirmationModalState() {
				const entries = {
					gelöscht: {
						title: 'Objekt löschen',
						text: 'Soll das Objekt wirklich gelöscht werden?',
					},
					online: {
						title: 'Objekt online setzen',
						text: 'Soll das Objekt wirklich online gestellt werden? Die Veröffentlichung kann bis zu 10 Minuten dauern.',
					},
					default: {
						title: '',
						text: '',
					},
				};

				return entries[this.dirtySelectedStatus] || entries.default;
			},

			/* Metadata */

			initialStatusNum() {
				return parseInt(this.dataset.FKM_Status || 1, 10);
			},

			statusItems() {
				const statusItems = this.$store.getters.setupStati
					.map((status) => {
						const variantsMap = {
							1: 'primary', /* entwurf */
							2: 'success', /* online */
							4: 'danger',  /* gelöscht */
						};

						const statusEntry = {
							value: parseInt(status.PKM_Status, 10),
							text: status.S_Status_Uppercase,
							variant: variantsMap[status.PKM_Status] || 'danger',
							changeInfo: InfoText.for(`status.${status.S_Status}`),
						};

						return statusEntry;
					});
				return statusItems;
			},

			status() {
				return {
					selectedItemValue: this.dirtySelectedStatusNum || this.initialStatusNum,
					items: this.statusItems,
				};
			},

			currentSelectedStatusItem() {
				const selectedItemValue = this.status.selectedItemValue;
				const selectedItem =
					this.status.items.find(item => (item.value === selectedItemValue)) || {
						title: '',
						variant: '',
					};

				return selectedItem;
			},

			publishDateTime() {
				return this.dataset.TS_online_Liveserver;
			},

			isValidPublishDateTime() {
				const momentDate = moment(this.publishDateTime, Const.DATETIMEFORMAT);
				const notPlanedMomentDate = moment(Const.NOTPLANNEDDATE, Const.DATETIMEFORMAT);
				return momentDate.isValid() &&
				       (momentDate.format(Const.DATEFORMATDEST) !==
				         notPlanedMomentDate.format(Const.DATEFORMATDEST));
			},

			goOfflineDateTime() {
				return this.dataset.TS_offline_Liveserver;
			},

			isValidGoOfflineDateTime() {
				const momentDate = moment(this.goOfflineDateTime, Const.DATETIMEFORMAT);
				const notPlanedMomentDate = moment(Const.NOTPLANNEDDATE, Const.DATETIMEFORMAT);
				return momentDate.isValid() &&
				       (momentDate.format(Const.DATEFORMATDEST) !==
				         notPlanedMomentDate.format(Const.DATEFORMATDEST));
			},

			pkStatus() {
				if (!this.dataset.pk_status) return [];
				const pkStatus = this.dataset.pk_status.reduce((data, item) => {
					if (!data[item.S_Modus]) {
						data[item.S_Modus] = {
							items: [],
							order: parseInt(item.U_Reihenfolge, 10),
						};
					}

					data[item.S_Modus].items.push(item);
					return data;
				},
				{});
				const tmp = [];
				Object.keys(pkStatus).forEach((key) => {
					const item = pkStatus[key];
					item.items = item.items.sort(
						(a, b) => parseInt(a.U_Reihenfolge, 10) - parseInt(b.U_Reihenfolge, 10),
					);
					tmp.push([key, item.items, item.order]);
				});
				tmp.sort((a, b) => a[2] - b[2]);
				return tmp;
			},
		},

		methods: {
			infoTextFor(infoKey) {
				const replacements = (infoKey in Const.max_chars
					&& {
						maxChars: Const.max_chars[infoKey],
					})
					|| {};

				return InfoText.for(infoKey, replacements);
			},

			getPkStatus(category) {
				return this.dataset[`FKM_PK_Status_${category}`];
			},

			getPkLabel(id) {
				let item = false;
				this.dataset.pk_status.forEach((value) => {
					if (parseInt(value.PKM_Status, 10) === parseInt(id, 10)) {
						item = value;
					}
				});
				return item.S_Status;
			},

			formatTimestamp(timestamp) {
				const mDate = moment(timestamp, Const.DATETIMEFORMAT);

				const notPlanedMomentDate = moment(Const.NOTPLANNEDDATE, Const.DATETIMEFORMAT);

				if (mDate.isValid() &&
				    (mDate.format(Const.DATEFORMATDEST) ===
				      notPlanedMomentDate.format(Const.DATEFORMATDEST))) {
					return 'Nicht geplant';
				}
				if (!mDate.isValid()) {
					return 'Bitte einen Zeitpunkt angeben...';
				}
				return mDate.format('lll');
			},

			handleStartpageChange(i, id, checked) {
				const genusChange = {};
				const strId = id.toString();

				if (checked) {
					const freeGenusDestinationIndex =
						this.basisgenusArr.findIndex(currGenus => currGenus.id === '0');

					if (freeGenusDestinationIndex < 0) {
						return;
					}
					const index = (freeGenusDestinationIndex > 0) ? freeGenusDestinationIndex + 1 : 0;
					const type = (index === 0) ? 'basis' : 'trait';
					const foundGenus =
						this.dataset.gattungen.find(currGenus => currGenus.PKM_Gattung === id);
					const value = foundGenus ? foundGenus.S_Gattung : '';

					genusChange[index] = {
						id: strId,
						type,
						value,
					};
				} else {
					const foundDestinationIndex =
						this.basisgenusArr.findIndex(currGenus => currGenus.id === strId);

					if (foundDestinationIndex < 0) {
						return;
					}
					const index = (foundDestinationIndex > 0) ? foundDestinationIndex + 1 : 0;
					const type = (index === 0) ? 'basis' : 'trait';

					genusChange[index] = {
						id: null,
						type,
						value: null,
					};
				}

				this.$store.dispatch('updateObjectSetupBasisGenus', genusChange);
			},

			handleLightscoutClassificationChange(index, lang, checked) {
				const langData = {
					code: lang,
					value: checked ? 1 : 0,
				};
				this.$store.dispatch('updateObjectSetupLightscoutClassification', langData);
			},

			handleVisibilityChange(index, value, checked) {
				this.$store.dispatch('updateObjectSetupVisibility', checked);
			},

			handleSynchblockChange(index, value, checked) {
				this.$store.dispatch('updateObjectSetupSynchblock', checked);
			},

			/* Meta */

			handleStatusClick(item) {
				this.dirtySelectedStatusNum = item.value;

				if (item.value === this.initialStatusNum) {
					this.change = null;
					return;
				}

				const selectedItem = this.statusItems.find(statusItem =>
					(statusItem.value === this.dirtySelectedStatusNum));

				if (selectedItem) {
					this.change = {
						info: selectedItem.changeInfo,
					};
				} else {
					this.change = null;
				}
			},

			handlePkStatusClick(item) {
				this.$store.dispatch('updateObjectSetupPkStatus', item).then((data) => {
					if (item.B_Mailclient === 'j') {
						const body = encodeURIComponent(data.body.replace(/\\r\\n/g, '\r\n'));
						const subject = encodeURIComponent(data.subject);
						location.href = `mailto:${data.empfaengeradresse || ''}?subject=${subject}&body=${body}`;
					}
				});
			},

			handlePublishDateTimeReset() {
				this.$store.dispatch('updateObjectSetupPublishDateTime', Const.CLEARDATE);
			},

			handleGoOfflineDateTimeReset() {
				this.$store.dispatch('updateObjectSetupGoOfflineDateTime', Const.CLEARDATE);
			},

			handleAsideChangeWithPreCheck() {
				const statusNum = this.dirtySelectedStatusNum.toString();

				const statiCheckNums = [
					this.$store.getters.statiAssoc.gelöscht,
					this.$store.getters.statiAssoc.online,
				];

				if (statiCheckNums.includes(statusNum)) {
					this.$refs.actionConfirmation.show();
				} else {
					this.handleAsideChange();
				}
			},

			handleAsideChange() {
				/* Status */
				const statusNum = this.dirtySelectedStatusNum.toString();

				if (statusNum !== this.initialStatusNum) {
					this.$store.dispatch('updateObjectSetupStatus', { status: statusNum })
					.then(() => {
						this.change = null;

						/* Nach dem Löschen eines Objekts direkt zum Dashboard springen */
						if (statusNum === this.$store.getters.statiAssoc.gelöscht) {
							this.$router.push({ path: '/dashboard' });
						}

						/* Zurücksetzen des Veröffentlichungsdatums,
						   wenn ein Statuswechsel von Online zu Entwurf erfolgt ist */
						if (this.initialStatusNum === this.$store.getters.statiAssoc.online &&
							statusNum === this.$store.getters.statiAssoc.entwurf) {
							this.$store.dispatch('updateObjectSetupPublishDateTime', Const.CLEARDATE);
						}
					})
					.catch(() => { /* TODO: Use (better) logging */ });
				}

				/* more ... */
			},

			handleAsideCancel() {
				/* Status */
				this.dirtySelectedStatusNum = null;
				this.change = null;

				/* more ... */
			},

			/* Sidebar */

			openSidebarFor(view) {
				const actionFunction = sidebarInputActions[view];

				if (!actionFunction) {
					 /* TODO: Use (better) logging */
					return;
				}

				const sidebarData = actionFunction.call(this);

				this.$store.dispatch('updateSidebar', sidebarData);
			},

			isSidebarFocused(key) {
				const sidebarStore = this.$store.state.sidebar;
				return sidebarStore.visible && sidebarStore.key === key;
			},

			triggerIDTextRTFExport() {
				this.$store.dispatch('triggerIdTextRTFExport')
					.then((data) => {
						const blob = new Blob([data], { type: 'application/rtf;charset=utf-8' });
						FileSaver.saveAs(blob, `ID-Text-Translation-${this.objectid}.rtf`);
					})
					.catch(() => { /* TODO: Use (better) logging */ });
			},
		},

		components: {
			ErcoTooltip,
			ErcoStatusBadge,
			ErcoTextInput,
			ErcoRadioGroup,
			ErcoCheckboxGroup,
		},
	};
</script>

<style lang="scss">
	.setup-view {
		height: 100%;

		& > .row {
			height: 100%;
		}

		.main {
			background-color: rgba(242, 242, 242, 1);
			border-right: 1px solid rgba(204, 204, 204, 1);
			padding: 1.5rem 4rem;
			height: 100%;
		}

		.aside {
			background-color: rgba(255, 255, 255, 1);
			padding: 1.5rem 1rem;

			.last-changes-link {
				text-align: right;
			}

			.status-dropdown {
				display: block;
				margin-bottom: 1rem;
			}

			.publish-date,
			.go-offline-date {
				input {
				 cursor: pointer;
				}
			}

			& > .process-block {
				.row {
					white-space: nowrap;

					.dropdown-toggle {
						&::after {
							float: right;
							margin-top: 0.5rem;
						}
					}
				}
			}

			& > .export-block {
				margin: 0.5rem 0;
			}

			& > .bottombar {
				margin-right: 0;
				padding-top: 1.5rem;
				padding-bottom: 1rem;
				position: absolute;
				bottom: 0;

				.info_ {
					& > ._title {
						font-weight: bold;
					}
				}
			}

			.padding-bottom {
				padding-bottom: 0.25rem;
			}
			.helptext {
					display: inline-flex;
					border: 1px solid #ccc;
					padding: .5rem 1rem;
					border-radius: 4px;
					margin-bottom: 0;
					height: 38px;
					vertical-align: middle;
			}

			.fullwidth {
				width: 20rem;
				& > .btn {
					width: 20rem;
					text-align: left;
				}

				& >.dropdown-menu {
					width: 20rem;
				}
			}

			.approval-indicator {
				display: inline-block;
				vertical-align: middle;
				background: #ECEEEF;
				border: 1px solid #CECECE;
				border-radius: 4px;
				height: 38px;
				padding: 0.5rem 0.5rem;
				&::after {
					content: '';
					display: inline-block;
					height: 1rem;
					width: 1rem;
					background-size: 100% 100%;
				}
				transition : border 500ms ease-out;
				&.-error {
					border: 1px solid #FF0000;
					background: #fff;
					&::after {
						content: '';
						display: inline-block;
						background: url('~@/assets/img/pencil-error.png') no-repeat center;
						background-size: 100% 100%;
						height: 1rem;
						width: 1rem;
					}
				}
				&.-progress {
					border: 1px solid #F5A623;
					background: #fff;
					&::after {
						content: '';
						display: inline-block;
						background: url('~@/assets/img/pencil-progress.png') no-repeat center;
						background-size: 100% 100%;
						height: 1rem;
						width: 1rem;
					}
				}
				&.-completed {
					border: 1px solid #5CB85C;
					background: #fff;
					&::after {
						content: '';
						display: inline-block;
						background: url('~@/assets/img/check-completed.png') no-repeat center;
						background-size: 100% 100%;
						height: 1rem;
						width: 1rem;
					}
				}
			}
		}

		.action-confirmation-modal {
			.modal {
				display: block;
			}

			._infotext {
				margin: 0.5rem 0 2rem;
			}

			.selected-obj-list-container {
				max-height: 300px;
				overflow: auto;

				> .selected-obj-list {
					> ._entry_ {
						display: flex;

						._title {
							flex: 1;
						}

						._id {
							flex: 0;
							padding-right: 0.5rem;
						}

						._badge {
							width: 4rem;
							text-align: right;
						}

					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// Setup.vue?51ff1b2c